module.exports = __webpack_public_path__ + "static/media/KMH_5384.36904ee3.jpg";